export default "__VITE_ASSET__2595aa52__"